module.exports = __webpack_public_path__ + "img/sld_mfm_battery_2_t1_b1_dark.8d78fd45.svg";